import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Debug logging
console.log('🔍 main.tsx: Starting application...');

// Check if root element exists
const rootElement = document.getElementById('root');
if (!rootElement) {
  console.error('❌ Root element not found!');
  document.body.innerHTML = `
    <div style="text-align: center; padding: 50px; font-family: Arial, sans-serif; color: red;">
      <h1>Error: Root element not found</h1>
      <p>The application cannot start because the root element is missing.</p>
    </div>
  `;
} else {
  console.log('✅ Root element found, initializing React...');
  
  try {
    const root = createRoot(rootElement);
    root.render(
      <StrictMode>
        <App />
      </StrictMode>
    );
    console.log('✅ React app rendered successfully');
  } catch (error) {
    console.error('❌ Error rendering React app:', error);
    rootElement.innerHTML = `
      <div style="text-align: center; padding: 50px; font-family: Arial, sans-serif; color: red;">
        <h1>Error al cargar la aplicación</h1>
        <p>Ha ocurrido un error al inicializar la aplicación.</p>
        <p style="font-size: 12px; color: #666;">${error.message}</p>
        <button onclick="window.location.reload()" style="margin-top: 20px; padding: 10px 20px; background: #007bff; color: white; border: none; border-radius: 5px; cursor: pointer;">
          Recargar Página
        </button>
      </div>
    `;
  }
}